import { type HTMLAttributes } from "react";
import { cn } from "../../utils/cn";

export type AvatarSize = "sm" | "md" | "lg";

export interface AvatarProps extends HTMLAttributes<HTMLSpanElement> {
  /** Fallback initials shown when no image src is set. */
  initials?: string;
  size?: AvatarSize;
  /** Use the fuchsia brand gradient instead of the solid dark fill. */
  gradient?: boolean;
  src?: string;
  alt?: string;
}

const sizes: Record<AvatarSize, string> = {
  sm: "size-6 text-[10px]",
  md: "size-8 text-body-sm",
  lg: "size-10 text-body",
};

export function Avatar({
  initials = "",
  size = "md",
  gradient = false,
  src,
  alt,
  className,
  ...rest
}: AvatarProps) {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full",
        "font-sans font-semibold text-grey-0",
        gradient
          ? "bg-gradient-to-br from-brand-500 to-brand-400"
          : "bg-grey-1000",
        sizes[size],
        className,
      )}
      {...rest}
    >
      {src ? (
        <img src={src} alt={alt ?? ""} className="size-full object-cover" />
      ) : (
        initials
      )}
    </span>
  );
}
